import {Component, EventEmitter, Input, OnInit, Optional, Output} from '@angular/core';
import {NzModalRef} from "ng-zorro-antd/modal";

@Component({
	selector: 'app-moniepoint-confirm-modal',
	templateUrl: './moniepoint-confirm-modal.component.html',
	styleUrls: ['./moniepoint-confirm-modal.component.scss']
})
export class MoniepointConfirmModalComponent implements OnInit {
	@Input()submitting = false;
	@Output() emitFunction = new EventEmitter();
	@Input() confirmText: string;
	@Input() confirmButtonText: string;
	@Input() title: string;
  @Input() designType:ConfirmModalDesignType;
  readonly DEFAULT_DESIGN_TYPE:ConfirmModalDesignType = 'default';
  readonly KAMONA:ConfirmModalDesignType = 'kamona';

	constructor(@Optional() private modalService: NzModalRef) {
	}

	ngOnInit(): void {
   if(!this.designType){
     this.designType = this.DEFAULT_DESIGN_TYPE;
   }
	}

	closeModal() {
		if (!this.submitting) {
			this.modalService.destroy();
		}
	}

	submit() {
		this.submitting = true;
		this.emitFunction.emit()
	}

}

export type ConfirmModalDesignType = | 'default' | 'kamona'
